'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _siema = require('siema');

var _siema2 = _interopRequireDefault(_siema);

var _functional = require('../utils/functional');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SubcollectionsCarousel = function () {
  function SubcollectionsCarousel(el) {
    var _this2 = this;

    (0, _classCallCheck3.default)(this, SubcollectionsCarousel);

    var _this = this;
    var context = { context: el };

    this.els = {
      el: el,
      itemsContainer: (0, _functional.getElement)('.col-Subcollections_List', context),
      items: (0, _functional.getElements)('.col-Subcollections_Item', context),
      controls: (0, _functional.getElement)('.col-Subcollections_Controls', context),
      prevControl: (0, _functional.getElement)('.col-Subcollections_Control-prev', context),
      nextControl: (0, _functional.getElement)('.col-Subcollections_Control-next', context)
    };

    this.mobileEnabled = this.els.el.hasAttribute('data-carousel-mobile-enabled');
    this.desktopEnabled = this.els.el.hasAttribute('data-carousel-desktop-enabled');

    // Viewport detection
    this.desktopMediaQuery = window.matchMedia('(min-width: 768px)');
    this.desktopMediaQuery.addEventListener('change', function () {
      /* eslint-disable no-mixed-operators */
      if (_this2.checkViewport() === 'desktop' && _this2.desktopEnabled === true && _this2.els.el.getAttribute('data-initialised') === 'false' || _this2.checkViewport() === 'mobile' && _this2.mobileEnabled === true && _this2.els.el.getAttribute('data-initialised') === 'false') {
        _this2.initCarousel(_this);
      }
      if (_this2.checkViewport() === 'desktop' && _this2.desktopEnabled === false && _this2.els.el.getAttribute('data-initialised') === 'true' || _this2.checkViewport() === 'mobile' && _this2.mobileEnabled === false && _this2.els.el.getAttribute('data-initialised') === 'true') {
        _this2.carousel.destroy(true);
        _this2.els.el.setAttribute('data-initialised', false);
      }
      /* eslint-enable no-mixed-operators */
    });

    /* eslint-disable no-mixed-operators */
    if (this.checkViewport() === 'desktop' && this.desktopEnabled || this.checkViewport() === 'mobile' && this.mobileEnabled) {
      this.initCarousel(_this);
    }
    /* eslint-enable no-mixed-operators */
  }

  (0, _createClass3.default)(SubcollectionsCarousel, [{
    key: 'initCarousel',
    value: function initCarousel(_this) {
      this.carousel = new _siema2.default({
        selector: this.els.itemsContainer,
        duration: 500,
        perPage: {
          0: 1.43,
          768: 3.33
        },
        onInit: function onInit() {
          _this.initialiseControls(this);
          _this.els.el.setAttribute('data-initialised', true);
        },
        onChange: function onChange() {
          _this.updateControlsDisabledStatus(this);
        }
      });
    }
  }, {
    key: 'updateControlsDisabledStatus',
    value: function updateControlsDisabledStatus(carousel) {
      var lastSlideIndex = this.els.items.length - 1;
      if (this.checkViewport() === 'mobile') {
        lastSlideIndex = lastSlideIndex - 0.43; // 0.43 is the remainer of the 1.43 cards shown in mobile
      }

      carousel.currentSlide === 0 ? this.els.prevControl.setAttribute('disabled', true) : this.els.prevControl.removeAttribute('disabled');

      carousel.currentSlide === lastSlideIndex ? this.els.nextControl.setAttribute('disabled', true) : this.els.nextControl.removeAttribute('disabled');
    }
  }, {
    key: 'initialiseControls',
    value: function initialiseControls(carousel) {
      var _this3 = this;

      // On load
      this.updateControlsDisabledStatus(carousel);

      // Events
      this.els.prevControl.addEventListener('click', (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return carousel.prev();

              case 2:

                _this3.updateControlsDisabledStatus(carousel);

              case 3:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this3);
      })));
      this.els.nextControl.addEventListener('click', (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2() {
        return _regenerator2.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return carousel.next();

              case 2:

                _this3.updateControlsDisabledStatus(carousel);

              case 3:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this3);
      })));
    }
  }, {
    key: 'checkViewport',
    value: function checkViewport() {
      return this.desktopMediaQuery.matches ? 'desktop' : 'mobile';
    }
  }]);
  return SubcollectionsCarousel;
}();

exports.default = SubcollectionsCarousel;